<template>
  <!-- 供应商列表 -->
  <div class="app-content">
    <AppPageTitle></AppPageTitle>
    <Content class="app-content__main">
      <Row>
        <Col :md='24' style="margin-bottom: 20px">
          <Button
            type="primary"
            icon="md-add"
            style="margin-right: 8px"
            @click="createItem"
          >新增供应商</Button>
        </Col>
      </Row>
      <Table
        :columns="queryColumn"
        :loading="loading"
        :data="queryData"
        border
        ref="dataTable"
      >
      <!-- <template slot-scope="{ row }"  slot="supplierCode">
        <span>{{ supplierCodeList.find(item => item.value === row.supplierCode)?.label }}</span>
      </template> -->
      <template slot-scope="{row, index}" slot="action">
        <Button
          type="text"
          class="text-link"
          size="small"
          icon="md-create"
          @click="updateItem(row, index)"
          >编辑
        </Button>
        <Button
          type="text"
          class="text-link"
          size="small"
          icon="md-trash"
          @click="deleteItem(row)"
          >删除
        </Button>
      </template>
      </Table>
      <Row>
        <Col :md="24" class="pagination">
          <Page
            :total="totalPage"
            :page-size="pageSize"
            :current="pageNum"
            :disabled="loading"
            @on-change="pageChange"
            @on-page-size-change="pageSizeChange"
            show-elevator show-sizer show-total />
        </Col>
      </Row>
    </Content>
    <SupplierCreateUpdate ref="supplierCreateUpdate" @success="createUpdateSuccess" />
  </div>
</template>

<script>
import utils from '../../utils'
import api from '../../api'
import { mapGetters } from 'vuex'
import SupplierCreateUpdate from '../../components/supplier/SupplierCreateUpdate'

export default {
  components: {
    SupplierCreateUpdate
  },
  data () {
    return {
      queryData: [],
      loading: false,
      totalPage: 1,
      pageSize: 10,
      pageNum: 1
    }
  },
  computed: {
    queryColumn () {
      return [
        {
          title: '供应商编号',
          key: 'id',
          minWidth: 150,
          align: 'center'
        },
        {
          title: '供应商名称',
          key: 'name',
          minWidth: 150,
          align: 'center'
        },
        {
          title: '供应商类别',
          key: 'supplierType',
          //   key: 'supplierCode',
          //   slot: 'supplierCode',
          minWidth: 190,
          align: 'center'
        },
        {
          title: '创建时间',
          key: 'createDate',
          align: 'center',
          minWidth: 190,
          render: (h, params) => {
            return h('span', utils.formatDateTime(params.row.createDate))
          }
        },
        {
          title: '备注',
          key: 'remark',
          minWidth: 190,
          align: 'center'
        },
        {
          title: '操作',
          key: 'id',
          minWidth: 150,
          slot: 'action',
          align: 'center'
        }
      ]
    },
    ...mapGetters('supplier', ['supplierCodeList'])
  },
  methods: {
    getData () {
      this.loading = true
      api.supplier.supplierList({
        pageNum: this.pageNum,
        pageSize: this.pageSize
      }).then((res) => {
        this.loading = false
        this.totalPage = +res.data.total
        this.queryData = res.data.records.map(row =>
          ({
            ...row,
            supplierType: this.supplierCodeList.find(item => item.value === row.supplierCode)?.label || ''
          })) ||
        []
      }).catch((err) => {
        this.loading = false
        this.$Message.error('获取供应商列表失败: ' + err.message)
      })
    },
    pageChange (pageNum) {
      this.pageNum = pageNum
      this.getData()
    },
    pageSizeChange (pageSize) {
      this.pageSize = pageSize
      this.pageNum === 1 ? this.getData() : this.pageNum = 1
    },
    // 新增
    createItem () {
      this.$refs.supplierCreateUpdate.show('create')
    },
    // 编辑
    updateItem (row, index) {
      this.$refs.supplierCreateUpdate.show('update', row, index)
    },
    // 删除
    deleteItem (row) {
      this.$Modal.confirm({
        title: '删除确认',
        content: `<p>您确定删除此供应商吗？</p>
                  <p><small class="text-danger">注：供应商下有商品或未付款完成的对账流水，请先删除其下所有商品并且所有对账流水已付款完成才能对供应商进行删除。</small></p>`,
        loading: true,
        onOk: () => {
          api.supplier.supplierDelete({
            supplierId: row.id
          })
            .then(() => {
              this.$Modal.remove()
              if (!(this.queryData.length - 1)) {
                this.pageNum = this.pageNum - 1 ? this.pageNum - 1 : 1
              }
              this.getData()
              this.updateStoreList()
              this.$Message.success('删除成功!')
            })
            .catch((err) => {
              this.$Modal.remove()
              setTimeout(() => {
                this.$Modal.error({
                  title: '抱歉',
                  content: '删除失败: ' + err.message
                })
              }, 400)
            })
        }
      })
    },
    // 新增，编辑成功
    createUpdateSuccess () {
      this.getData()
      this.updateStoreList()
    },
    // 更新store supplierList
    updateStoreList () {
      this.$store.dispatch('supplier/getSupplierList')
    }
  },
  created () {
    if (!this.supplierCodeList.length) {
      this.$store.dispatch('supplier/getSupplierCode')
    }
    this.getData()
  }
}
</script>
